import _extends from "@babel/runtime/helpers/extends";
import { createTranslationsProvider } from '@wix/package-picker-common';
import React from 'react';
const PP_AUTONOMOUS_TRANSLATIONS_NAMESPACE = 'packagePickerAutonomous';
const {
  TranslationsProvider,
  useTranslations
} = createTranslationsProvider({
  providerName: 'AutonomousTranslationsProvider',
  namespace: PP_AUTONOMOUS_TRANSLATIONS_NAMESPACE
});
export const AutonomousTranslationsProvider = props => {
  const [resources, setResources] = React.useState(null);
  const language = props.i18n.options.lng ?? 'en';

  /* TODO: Once will finish arranging the translations under the package-picker-autonomous package, we need to change to relative assets path: ../assets/locale/messages_${language}.json`
   * For now, we are using `@wix/premium-purchase-plan-translations`.
   **/
  React.useEffect(() => {
    import( /* webpackChunkName: "package-picker-autonomous-translations" */`@wix/premium-purchase-plan-translations/src/assets/locale/messages_${language}.json`).then(res => {
      setResources(res.default);
    }).catch(e => {
      console.log(e);
    });
  }, [language]);
  return /*#__PURE__*/React.createElement(TranslationsProvider, _extends({
    resources: resources
  }, props));
};
export { useTranslations as useAutonomousTranslations };
//# sourceMappingURL=AutonomousTranslationsProvider.js.map